export default __webpack_public_path__ + "static/media/4c5b156e971bb4c04a2308887975cd1a1581602273333.6bc33cf6.webp";